import {ErrorMessages} from 'constants/Errors';

import {AxiosResponse} from 'axios';
import {call, put} from 'redux-saga/effects';
import {getBeersList} from 'services/beers';
import {handleError} from 'store/app/error/saga';
import ApiData from 'typescript/interfaces/ApiData';
import {Beer} from 'typescript/models/Beer';

import {setBeersAC, setBeersIncludedAC, setBeersPageInfoAC, setLoadingAC} from '../beerSlice';
import {getBeersACS} from '../requestAC';

export function* getBeers(action: ReturnType<typeof getBeersACS>) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {page, ...dto} = action.payload;

  try {
    yield put(setLoadingAC(true));

    const response: AxiosResponse<ApiData<Beer[]>> = yield call(getBeersList, {...dto, page: 1});
    const {data} = response;

    yield put(setLoadingAC(false));
    yield put(setBeersAC(data.data));
    yield put(setBeersPageInfoAC({totalPages: data.meta.total_pages, totalCount: data.meta.total_count}));
    yield put(setBeersIncludedAC(data.included));
  } catch (error) {
    yield call(handleError, error, ErrorMessages.DATA);
  }
}
